const topbar = {
    docs: 'الوثائق',
    help: 'المساعدة',
    subscription: 'الاشتراك',
};
export default Object.freeze(topbar);
